import styled from 'styled-components'
import { Checkbox } from 'antd'

export const MyCheckbox = styled(Checkbox)<{
  $dark?: boolean
}>`
  color: ${props => (props.$dark ? props.theme.light1 : props.theme.dark1)};
  .ant-checkbox-inner {
    border-radius: 50%;
    width: 16px;
    height: 16px;
    border-color: ${props =>
      props.$dark ? props.theme.dark3 : props.theme.light1};
    background: ${props => (props.$dark ? 'none' : '#fff')};
    &:after {
      left: 20%;
      width: 5px;
      height: 9px;
    }
  }
  .ant-checkbox {
    &:hover {
      .ant-checkbox-inner {
        border-radius: 50%;
      }
    }
  }

  .ant-checkbox-checked {
    .ant-checkbox-inner {
      border-color: ${props => props.theme.primaryColor};
      background: ${props => props.theme.primaryColor};
    }
    &::after {
      border-color: transparent;
    }
  }
  .ant-checkbox-disabled {
    &.ant-checkbox-checked {

      .ant-checkbox-inner {
        border-color: transparent;
        &::after {
          border-color: ${props => props.theme['neutral-900']};
        }
      }
    }
  }
}
`
